<template>
  <div
    class="TUsuarios"
    data-testid="TUsuarios"
  >
    <div class="TUsuarios__Header">
      <slot name="navegacao" />
    </div>
    <div class="TUsuarios__TabelasUsuarios">
      <slot name="tabelas" />
    </div>
    <slot name="modais" />
  </div>
</template>

<style lang="scss" scoped>
  @import "./TUsuarios.scss";
</style>
